export const RESET_OS_OBJECT = 'OS_OBJECTS/RESET_OS_OBJECT';
export const SET_SUMMARY_OS_OBJECTS = 'OS_OBJECTS/SET_SUMMARY_OS_OBJECTS';
export const SET_PAGINATION_OS_OBJECTS = 'OS_OBJECTS/SET_PAGINATION_OS_OBJECTS';
export const SET_DETAILED_OS_OBJECT = 'OS_OBJECTS/SET_DETAILED_OS_OBJECT';
